import { Check } from "lucide-react";
import { fmtDate } from "@/lib/format";

// steps: [{name, state: 'done'|'current'|'todo', meta}]
export const VerticalStepper = ({ steps }) => (
  <ol className="relative space-y-5">
    {steps.map((s, i) => (
      <li key={s.name} className="relative flex gap-3" data-testid={`stepper-step-${i + 1}`}>
        {i < steps.length - 1 && (
          <span className={`absolute left-[11px] top-7 h-[calc(100%-4px)] w-px ${s.state === "done" ? "bg-emerald-400" : "bg-slate-200"}`} />
        )}
        <StepDot state={s.state} n={i + 1} />
        <div className="min-w-0">
          <p className={`text-sm font-medium ${s.state === "todo" ? "text-slate-400" : "text-slate-900"}`}>
            {s.name}{s.state === "current" && <span className="text-amber-600"> - in progress</span>}
          </p>
          <p className={`text-xs ${s.state === "current" ? "text-amber-700" : "text-slate-500"}`}>{s.meta}</p>
        </div>
      </li>
    ))}
  </ol>
);

export const StepDot = ({ state, n }) => (
  <span
    className={`relative z-10 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-[11px] font-semibold ${
      state === "done" ? "border-emerald-500 bg-emerald-500 text-white"
        : state === "current" ? "border-amber-500 bg-amber-50 text-amber-700 ring-4 ring-amber-100"
          : "border-slate-300 bg-white text-slate-400"}`}
  >
    {state === "done" ? <Check className="h-3.5 w-3.5" /> : n}
  </span>
);

export const HorizontalStepper = ({ steps }) => (
  <ol className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
    {steps.map((s, i) => (
      <li key={s.name} data-testid={`stepper-step-${i + 1}`} className="relative">
        <div className="flex items-center gap-2">
          <StepDot state={s.state} n={i + 1} />
          {i < steps.length - 1 && <span className={`hidden h-px flex-1 lg:block ${s.state === "done" ? "bg-emerald-400" : "bg-slate-200"}`} />}
        </div>
        <p className={`mt-2 text-sm font-medium ${s.state === "todo" ? "text-slate-400" : "text-slate-900"}`}>{s.name}</p>
        <p className={`text-xs ${s.state === "current" ? "text-amber-700" : "text-slate-500"}`}>{s.meta}</p>
      </li>
    ))}
  </ol>
);

// Build step states from a doc with {stage, status, history} and a stages meta list.
export const buildSteps = (stages, doc, finished) =>
  stages.map((st, i) => {
    const h = [...(doc.history || [])].reverse().find((x) => x.stage === i && ["approved", "completed"].includes(x.action));
    if (finished || i < doc.stage) return { name: st.name, state: "done", meta: `${h?.by || "Completed"} · ${fmtDate(h?.at)}` };
    if (i === doc.stage) return { name: st.name, state: "current", meta: `${st.role_label} pending ${doc.days} day${doc.days === 1 ? "" : "s"}` };
    return { name: st.name, state: "todo", meta: "Not started" };
  });
